const dev = {
  apiBaseUrl: 'http://localhost:3000/api/v1',
};

const hml = {
  apiBaseUrl: 'https://apihomologacao.divulgai.app/api/v1',
};

const prod = {
  apiBaseUrl: 'https://api.divulgai.app/api/v1',
};

const stage = process.env.REACT_APP_STAGE;

const config = (() => {
  if (stage === 'dev') {
    return dev;
  }
  if (stage === 'homologation') {
    return hml;
  }
  return prod;
})();

export default config;



// WEBPACK FOOTER //
// ./src/config.js